<template>
  <div class="view-wrap">
    <div class="view-content bg-regular">
      <div v-if="error" class="text-center error-wrap">
        <div class="error-msg">Rawr! Something went wrong on our end, please try again in a few minutes.</div>
      </div>
      <section>
        <div class="section-inner">
          <div class="login-wrap">
            <div v-if="iOSorAndroid" class="text-center mobile-devices">
              <div class="login-bear blue">
                <div class="inner-circle">
                  <img src="./images/bear.svg" class="bear-img happy">
                </div>
              </div>
              <h1 class="h3">Rawr!</h1>
              <p>Use the RememBear app to securely log in</p>
              <a id="deviceLoginBtn" href="remembear://login" class="btn btn-lg">Log In</a>
            </div>
            <div v-else>
              <div class="login-bear" :class="currentColour">
                <div class="spinner"></div>
                <div class="inner-circle">
                  <img src="./images/bear.svg" class="bear-img happy">
                  <img src="./images/bear-ermmm.svg" class="bear-img sad">
                </div>
              </div>
              <div id="login-type" class="text-center" :class="{'visible' : showContent || extensionInstalled}">
                <transition name="fade" mode="out-in">
                  <div key="1" v-if="shouldShowLoggedIn">
                    <h1 class="h3">Success!</h1>
                    <p>Securely logged In</p>
                  </div>
                  <div key="2" v-if="shouldShowLogin">
                    <h1 class="h3">Logging In</h1>
                    <p>Securely logging in to RememBear</p>
                  </div>
                  <div key="3" v-if="shouldShowPaired" id="state-pair">
                    <h1 class="h3">Rawr!</h1>
                    <p>RememBear isn't paired with your browser</p>
                    <button @click="requestToken()" class="btn btn-lg">Pair Now to Log In</button>
                    <p class="light-text small-copy">You'll need the <router-link :to="{ name: 'download' }">RememBear app</router-link> installed to securely log in.</p>
                  </div>
                  <div key="4" v-if="shouldShowLocked">
                    <h1 class="h3">Rawr!</h1>
                    <p>Please unlock your RememBear</p>
                    <button v-show="dismissed" @click="requestToken()" class="btn btn-lg">Unlock Now</button>
                  </div>
                  <div key="5" v-if="shouldShowInstall" class="state-install-extension">
                    <h1 class="h3">Rawr!</h1>
                    <p>
                      You’ll need the RememBear browser extension and desktop app installed to securely log in.
                    </p>
                    <div class="buttons">
                      <a v-if="!is.safari()" :href="downloadLink" class="btn btn-lg">Install Extension</a>
                      <router-link :to="{ name: 'download' }" class="btn btn-lg">Install Desktop App</router-link>
                    </div>
                    <p v-if="is.safari()" class="fine-print">The Safari browser extension comes bundled with your Mac&nbsp;download</p>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import is from 'is_js'

export default {
  name: 'login',
  data () {
    return {
      is: is,
      iOSorAndroid: is.ios() || is.android(),
      dismissed: false,
      extensionInstalled: false,
      extensionStatus: {},
      shouldShowLoggedIn: false,
      showContent: false,
      token: '',
      error: false
    }
  },
  computed: {
    downloadLink: function () {
      let link = this.external.downloadLinks.chrome
      if (is.firefox()) {
        link = this.external.downloadLinks.firefox
      }
      return link
    },
    shouldShowInstall: function () {
      if (this.token) return false
      return !this.extensionInstalled && this.showContent
    },
    shouldShowPaired: function () {
      if (this.token) return false
      if (!this.extensionInstalled) return false
      if (this.shouldShowLoggedIn) return false
      return !this.extensionStatus.paired
    },
    shouldShowLocked: function () {
      if (this.token) return false
      if (!this.extensionInstalled) return false
      if (this.shouldShowLoggedIn) return false
      return !!this.extensionStatus.locked && this.extensionStatus.paired
    },
    shouldShowLogin: function () {
      if (this.token) return true
      if (!this.extensionInstalled) return false
      if (this.shouldShowLoggedIn) return false
      return !!this.extensionStatus.paired && !this.extensionStatus.locked
    },
    currentColour: function () {
      if (!this.showContent) return 'blue'
      let color = 'grey'
      if (this.shouldShowLogin) color = 'blue'
      if (this.shouldShowLoggedIn) color = 'green'
      return color
    }
  },
  created: function () {
    if (!this.iOSorAndroid) {
      window.addEventListener('message', this.extensionHandler)
    }
    setTimeout(() => {
      if (!this.showContent) {
        this.showContent = true
      }
    }, 2100)
  },
  methods: {
    refresh: function () {
      location.reload()
    },
    doLogin: function () {
      this.error = false
      setTimeout(() => {
        this.shouldShowLoggedIn = true
        setTimeout(() => {
          this.loginSuccess()
        }, 1000)
      }, 1500)
    },
    extensionHandler: function (event) {
      if (window.origin !== event.origin || window.location.href !== event.source.location.href) return
      if (event.data.source === 'FROM_EXTENSION') {
        this.extensionInstalled = true
        this.showContent = true
        if (event.data.type) {
          switch (event.data.type) {
            case 'APP_STATUS':
              this.extensionStatus = event.data.param
              if (event.data.param.paired) {
                if (!this.dismissed || !(event.data.param.locked === true)) {
                  this.requestToken()
                }
              }
              break
            case 'TOKEN':
              if (event.data.param.token) {
                this.token = event.data.param.token
                this.doLogin()
              } else if (event.data.param.error) {
                if (event.data.param.error === 'dismissed') {
                  this.dismissed = true
                } else if (event.data.param.error === 'authFailed') {
                  this.error = true
                } else {
                  this.error = true
                }
              }
              break
          }
        }
      }
    },
    loginSuccess: function () {
      let redirect = ''
      if (this.$store.getters.nextRoute.path) {
        redirect = (this.$store.getters.nextRoute.path).substring(1)
        if (this.$store.getters.nextRoute.query.coupon) {
          redirect += '?coupon=' + this.$store.getters.nextRoute.query.coupon
        }
        redirect = '&redirect=' + encodeURIComponent(redirect)
      }

      window.location.href = this.ENV.apiBaseUrl + '/web/account/login?token=' + this.token + redirect
    },
    requestToken: function () {
      window.postMessage({ source: 'FROM_PAGE', command: 'LOGIN' }, this.ENV.baseURL)
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('message', this.extensionHandler)
  }
}
</script>

<style scoped lang="stylus" src="./login.styl" >



// WEBPACK FOOTER //
// src/views/login/login.vue